import { createAsyncAction } from 'typesafe-actions';
import { FacilityType } from '@rootCommon/types/glossary';

export const fetchFacilityTypes = createAsyncAction(
  'FETCH_FACILITY_TYPE_REQUEST',
  'FETCH_FACILITY_TYPE_SUCCESS',
  'FETCH_FACILITY_TYPE_FAILURE',
)<undefined, FacilityType[], Error>();

export default fetchFacilityTypes;
